import lrDataBoard from './_src/lrDataBoard.vue'

lrDataBoard.install = function(Vue) {
  Vue.component(lrDataBoard.name, lrDataBoard)
}

export default lrDataBoard